import { Users } from '@just-in-types';
import * as moment from 'moment';
import { AnyAction, Dispatch } from 'redux';
import { firestore } from '../../firebase';

const checkInsRef = firestore.collection('checkIns');

export type GetCheckIns = (
  {
    businessId,
    userId,
  }: {
    businessId: string;
    userId: string;
  },
) => (dispatch: Dispatch) => Promise<void>;
export const GET_CHECKINS = 'user.GET_CHECKINS';
export const getCheckIns = ({
  businessId,
  userId,
}: {
  businessId: string;
  userId: string;
}) => async (dispatch: Dispatch) => {
  const querySnapshot = await checkInsRef
    .where('businessId', '==', businessId)
    .where('userId', '==', userId)
    .get();
  const checkIns: Users.CheckIn[] = [];

  querySnapshot.forEach(doc => {
    const checkInData = doc.data() as Users.CheckIn;

    checkIns.push({ ...checkInData, checkInId: doc.id });
  });

  dispatch({ type: GET_CHECKINS, payload: checkIns });
};

export const SET_UPDATING_MODE = 'user.SET_UPDATING_MODE';
export const setUpdatingMode = (updating: boolean) => (dispatch: Dispatch) =>
  dispatch({ type: SET_UPDATING_MODE, payload: updating });

export type WatchCoupons = (
  userId: string,
) => (dispatch: Dispatch<AnyAction>) => () => void;
export const WATCH_COUPONS = 'user.WATCH_COUPONS';
export const watchCoupons = (userId: string) => (
  dispatch: Dispatch<AnyAction>,
) =>
  firestore.collection(`users/${userId}/coupons`).onSnapshot(
    querySnapshot => {
      const coupons: Users.Coupon[] = [];

      querySnapshot.forEach(coupon => {
        const couponData = coupon.data() as Users.Coupon;
        const expires = couponData.expires_date
          ? 'toDate' in couponData.expires_date
            ? couponData.expires_date.toDate()
            : couponData.expires_date
          : null;

        const couponObject = {
          ...couponData,
          couponId: coupon.id,
          userId,
        };

        if (!expires || moment().isBefore(expires)) {
          coupons.push(couponObject);
        }
      });

      return dispatch({ payload: coupons, type: WATCH_COUPONS });
    },
    error => {
      throw error;
    },
  );



// WEBPACK FOOTER //
// ./src/store/actions/userTempActions.ts